import * as z from "zod";

/**
 * Called by the app's server: exchanges a one-time code for the store's
 * public API key. Field names follow OAuth's token request and response.
 */
export const exchangeTeamAccessCode = {
  name: "exchangeTeamAccessCode" as const,
  input: z.object({
    client_id: z.string(),
    client_secret: z.string(),
    code: z.string(),
    redirect_uri: z.string(),
    code_verifier: z.string(),
  }),
  output: z.object({
    access_token: z.string(),
    token_type: z.literal("bearer"),
    /** `team` and every granted public API scope. */
    scope: z.string(),
    /** The store the key belongs to. */
    store_id: z.string(),
    /** The store's display name, so the app needs no other call to show it. */
    store_name: z.string(),
  }),
};
